import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import ScrollBox from '../../../components/ScrollBox';
import { Box, Button, IconButton, Stack, Typography, useTheme } from '@mui/material';
import CtrlFillLabelTxtField from '../../../components/CtrlFillLabelTxtField';
import BgBoxOld from '../../../components/BgBoxOld';
import { AddCircle, Delete } from '@mui/icons-material';
import CtrlCustomDropDownOld from '../../../components/CtrlCustomDropDownOld';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import { addPoServ } from '../../../services/com-service';
import { checkNumFormat } from '../../../utils/format';

const prodStatusArr = [
    { value: "awaiting_post_po_clarify", label: "AWAITING POST-PO CLARIFICATION" },
    { value: "packing_in_prog", label: "PACKING IN PROGRESS" },
    { value: "back_order", label: "BACK ORDER" },
    { value: "partially_del", label: "PARTIALLY DELIVERED" },
    { value: "del_completed", label: "DELIVERY COMPLETED" }];

const paidArr = [
    { value: "1", label: "YES" },
    { value: "0", label: "NO" }];


function AddPotPage() {
    const theme = useTheme();
    const location = useLocation();
    const { setLoadingScreen, setSelComValue } = useAuthContext();
    const { comId, comName, comLogo, potProjDet, pgNo, s, st } = location.state;
    const navigate = useNavigate();
    const txtFieldProps = { fontSize: 12, height: 35 };
    const [formErrors, setFormErrors] = useState({});
    const [products, setProducts] = useState([
        {
            lineNo: "",
            comProdIdStrg: "",
            mfrName: "",
            prodName: "",
            orderedQty: "",
            deliveredQty: "",
            balQty: "",
            prodStatus: "",
            expecDelDate: "",
            estTimeArr: "",
            isPaid: "",
            amtcRemarks: "",
            doDataArr: [
            ],
        },
    ]);

    useEffect(() => {
        if (!comId) {
            notify("error", "Company not found!--");
            navigate(-1);
        } else {
            setSelComValue({ comId, comName, comLogo, potProjDet })
        }
    }, [comId, comName, comLogo, potProjDet]);



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                comId, poReqNo: inputObject.poReqNo, delLocation: inputObject.delLocation,
                poProdArr: products.map((product) => ({
                    ...product,
                    lineNo: checkNumFormat(product.lineNo),
                    orderedQty: checkNumFormat(product.orderedQty),
                    deliveredQty: checkNumFormat(product.deliveredQty),
                    balQty: checkNumFormat(product.balQty),
                    isPaid: checkNumFormat(product.isPaid),
                    doDataArr: product.doDataArr.map((doItem) => ({
                        ...doItem,
                        doLineNo: checkNumFormat(doItem.doLineNo),
                        deliveredQty: checkNumFormat(doItem.deliveredQty),
                    })),
                })),
            }
            console.dir(payload);
            const { message } = await addPoServ(payload);
            notify("success", message);

            navigate(`${route.amtcPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        navigate(`${route.amtcPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
    }

    function validate(values) {
        const errors = {};

        if (!values.poReqNo)
            errors.poReqNo = "PO NUMBER is required!";

        return errors;
    };



    const addProduct = () => {
        setProducts([
            ...products,
            {
                lineNo: "",
                comProdIdStrg: "",
                mfrName: "",
                prodName: "",
                orderedQty: "",
                deliveredQty: "",
                balQty: "",
                prodStatus: "",
                expecDelDate: "",
                estTimeArr: "",
                isPaid: "",
                amtcRemarks: "",
                doDataArr: [

                ],
            },
        ]);
    };

    const addDeliveryOrder = (prodIndex) => {
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr.push({
            doLineNo: "",
            doIdStrg: "",
            deliveredQty: "",
            deliveredAt: ""
        });
        setProducts(updatedProducts);
    };

    const removeProduct = (index) => {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
    };

    const removeDeliveryOrder = (prodIndex, doIndex) => {
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr.splice(doIndex, 1);
        setProducts(updatedProducts);
    };

    const handleProdValChange = (index, e) => {
        const { name: field, value } = e.target;
        const updatedProducts = [...products];
        updatedProducts[index][field] = value;
        setProducts(updatedProducts);
    };


    const handleDoValChange = (prodIndex, doIndex, e) => {
        const { name: field, value } = e.target;
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr[doIndex][field] = value;
        setProducts(updatedProducts);
    };



    return (
        <Stack height={"100%"} width={"100%"}>
            <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%" }}>
                <Stack direction={'row'} justifyContent='space-between' alignItems='center' my={1} pl={5} pr={10}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>ADD PURCHASE ORDER</Typography>
                    <Stack direction={'row'} alignItems='center' gap={1} >
                        <Button variant="text" sx={{ height: 30, width: 120, color: theme.palette.custom.btn }} onClick={handleCancel}>{"Cancel"}</Button>
                        <Button variant="contained" type='submit' sx={{ height: 30, width: 120, color: "white", backgroundColor: theme.palette.custom.btn }}>{"ADD PO"}</Button>
                    </Stack>
                </Stack>
                <BgBoxOld height={"93%"} py={1}>
                    <Stack direction={"row"} >
                        <FillLabelTxtField name="poReqNo" title={"PO NUMBER"} errMsg={formErrors.poReqNo} {...txtFieldProps} />
                        <Box width={100} />
                        <FillLabelTxtField name="delLocation" title={"DELIVERY LOCATION"} {...txtFieldProps} />
                    </Stack>

                    <Stack direction={'row'} alignItems='center' mt={1} >
                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>ADD PRODUCT</Typography>
                        <IconButton onClick={addProduct}>
                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                        </IconButton>
                    </Stack>
                    <ScrollBox height={"82%"} >
                        {products.map((prod, pi) => (
                            <Box key={pi} sx={{
                                px: 2, py: 2, backgroundColor: "#ffff", borderRadius: 1.4, border: 1, position: "relative", mb: 2, height: 400,
                                borderColor: '#E3E3E3', width: "100%", display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "center"
                            }}>
                                <Stack justifyContent={"center"} alignItems={"center"} width={"55%"} pl={2} gap={2}>
                                    <Stack direction={"row"} gap={2} alignItems={"center"}>
                                        <CtrlFillLabelTxtField name="lineNo" title={"POL"}  {...txtFieldProps} width={100}
                                            type="number" step={1} value={prod.lineNo} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="comProdIdStrg" title={"MATERIAL CODE"} {...txtFieldProps} width={250}
                                            value={prod.comProdIdStrg} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="prodName" title={"DESCRIPTION"}  {...txtFieldProps} width={250}
                                            value={prod.prodName} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={4}>
                                        <CtrlFillLabelTxtField name="mfrName" title={"ORIGINAL MNFR"} {...txtFieldProps} width={300}
                                            value={prod.mfrName} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDownOld title={"STATUS"} name={"prodStatus"} ddArr={prodStatusArr}
                                            {...txtFieldProps} width={300} value={prod.prodStatus} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlFillLabelTxtField name="orderedQty" title={"PO QTY	"}  {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.orderedQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="deliveredQty" title={"DELIVERED QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.deliveredQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="balQty" title={"REMAINING QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.balQty} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlFillLabelTxtField name="estTimeArr" type={"date"} title={"ETA"}  {...txtFieldProps} width={200}
                                            value={prod.estTimeArr} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="expecDelDate" type={"date"} title={"ETD"} {...txtFieldProps}
                                            width={200} value={prod.expecDelDate} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDownOld title={"PAYMENT STATUS"} name={"isPaid"} ddArr={paidArr} {...txtFieldProps}
                                            width={200} value={prod.isPaid} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"}>
                                        <CtrlFillLabelTxtField name="amtcRemarks" title={"AMTC REMARKS"} {...txtFieldProps} width={635} multiline={true}
                                            height={70} rows={3} value={prod.amtcRemarks} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>

                                    <IconButton
                                        sx={{ position: "absolute", top: -3, left: -8 }} aria-label="delete"
                                        onClick={() => removeProduct(pi)}>
                                        <Delete color='error' />
                                    </IconButton>
                                </Stack>
                                <Box width={2} bgcolor={'#E3E3E3'} height={"100%"} mx={2} />

                                <Stack justifyContent={"start"} height={"100%"} width={"45%"}>
                                    <Stack direction={'row'} alignItems='center'>
                                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>ADD DELIVERY ORDER</Typography>
                                        <IconButton onClick={() => addDeliveryOrder(pi)}>
                                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                                        </IconButton>
                                    </Stack>
                                    <ScrollBox height={"80%"} width={"100%"}>{
                                        prod.doDataArr.map((doItem, di) => (
                                            <Stack key={`${pi}_${di}`} sx={{
                                                px: 2, py: 2, borderRadius: 1.4, gap: 2, mb: 2,
                                                backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%", position: "relative"
                                            }}>
                                                <Stack direction={"row"} gap={2} alignItems={"center"}>
                                                    <CtrlFillLabelTxtField name="doLineNo" title={"DOL"}  {...txtFieldProps} width={200} type="number"
                                                        step={1} value={doItem.doLineNo} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlFillLabelTxtField name="doIdStrg" title={"DO NUMBER"} {...txtFieldProps} width={300}
                                                        value={doItem.doIdStrg} onChange={(e) => handleDoValChange(pi, di, e)}
                                                    />
                                                </Stack>
                                                <Stack direction={"row"} gap={2} alignItems={"center"}>
                                                    <CtrlFillLabelTxtField name="deliveredQty" title={"QTY"}  {...txtFieldProps} width={200} type="number"
                                                        step={1} value={doItem.deliveredQty} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlFillLabelTxtField name="deliveredAt" type={"date"} title={"DELIVERED ON"} {...txtFieldProps}
                                                        width={300} value={doItem.deliveredAt} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                </Stack>
                                                {/* <Stack direction={"row"} gap={2}>
                                                    <CtrlFillLabelTxtField name="invNo" title={"INVOICE NO"}  {...txtFieldProps} width={200}
                                                        value={doItem.invNo} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlFillLabelTxtField name="invDate" title={"INVOICE DATE"} {...txtFieldProps} width={200}
                                                        type="date" step={1} value={doItem.invDate} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlFillLabelTxtField name="invStatus" title={"INVOICE STATUS"} {...txtFieldProps} width={200}
                                                        step={1} value={doItem.invStatus} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                </Stack> */}
                                                <IconButton
                                                    sx={{ position: "absolute", top: -3, right: -8 }} aria-label="delete"
                                                    onClick={() => removeDeliveryOrder(pi, di)}>
                                                    <Delete color='error' />
                                                </IconButton>
                                            </Stack>))}
                                    </ScrollBox>
                                </Stack>
                            </Box>
                        ))}
                    </ScrollBox>
                </BgBoxOld>
            </form>
        </Stack>
    )
}

export default AddPotPage